import { render, staticRenderFns } from "./UpdateSmsTemplate.vue?vue&type=template&id=03280e2c"
import script from "./UpdateSmsTemplate.vue?vue&type=script&lang=js"
export * from "./UpdateSmsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports